<template>
  <div class="payment-iframe__status">
    <div class="payment-iframe__icon" :class="`payment-iframe__icon--${messageType}`"></div>
    <div class="payment-iframe__title">{{ getMessageInfo.title }}</div>
    <div class="payment-iframe__text">
      <p v-for="(text, text_id) in getMessageInfo.text" :key="text_id" v-html="text"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "MycomPaymentMessage",

  props: {
    messageType: String,
  },

  computed: {
    getMessageInfo() {
      return this.$t(`payment_mycom.${this.messageType}`, { returnObjects: true });
    },
  },
};
</script>
